const SelectInput = ({
  label,
  name,
  register,
  errors,
  options,
  validationRules = {},
  defaultValue = "",
  helpText,
  placeHolder= null,
  className = "",
  fullWidth = true,
  showLabel= true,
  disabled=false,
  disablePlaceholderOption = true,
  ...rest
}) => (
  <div className={`mb-2 ${fullWidth ? "w-full" : ""} ${className}`} {...rest}>
    {showLabel && (
      <label className="label label-text" htmlFor={name}>
      {label}
    </label>
    )}
    <select
      id={name}
      disabled={disabled}
      defaultValue={defaultValue}
      className={`select border border-gray-300 focus:outline-none hover:border-primary focus:ring-2 focus:ring-primary ${
        fullWidth ? "w-full" : ""
      }`}
      {...register(name, validationRules)}
    >
      <option value="" disabled={disablePlaceholderOption}>
        {placeHolder ?  placeHolder : 'Select ' + label}
      </option>
      {options.map((option, index) => (
        <option key={index} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
    {errors[name] && <p className="text-sm text-red-400">{errors[name].message}</p>}
    {helpText && <p className="text-xs text-gray-500 mt-1">{helpText}</p>}
  </div>
);

export default SelectInput;
